import { styled } from 'linaria/lib/react';
import React from 'react';
import { authHelper } from '@root/utils/authHelper/AuthHelper';
import useAuthDataStore from '@root/store/useAuthDataStore';
import { PhoneProfile } from './PhoneProfile';
import { ButtonDone } from '../Cyber/buttons/ButtonDone';
import { ExitIcon } from './ExitIcon';
import { BurgerAvatar } from './BurgerAvatar';
export const BurgerMenuList = () => {
  const phone = useAuthDataStore().getPhone() || '';
  return <WrapperBurgerMenuList>
      {phone ? <PhoneProfile phone={phone} /> : <WrapperNoPhone>
          <BurgerAvatar />
          <Text>Мой профиль</Text>
        </WrapperNoPhone>}
      <ButtonDone modal startIcon={<ExitIcon />} height={40} title="выйти" onClick={authHelper.logOut} />
    </WrapperBurgerMenuList>;
};
const WrapperBurgerMenuList = /*#__PURE__*/styled("div")({
  name: "WrapperBurgerMenuList",
  class: "w11e4eob"
});
const WrapperNoPhone = /*#__PURE__*/styled("div")({
  name: "WrapperNoPhone",
  class: "w1sl6yzl"
});
const Text = /*#__PURE__*/styled("div")({
  name: "Text",
  class: "tj6b3uy"
});

require("./BurgerMenuList.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./BurgerMenuList.tsx");